export default {
	// Custom Page Meta
	seo_meta_title_leaguepass: 'League Pass - Canlı NBA Maçlarını İzle | NBA.com',
	seo_meta_desc_leaguepass: 'League Pass ile NBA maçlarını canlı veya seç-izle seçeneğiyle seyredin. Hesabınıza buradan erişin.',
	seo_meta_keywords_leaguepass: 'NBA Videoları, NBA Özetler, Basketbol Videoları, en güzel hareketler, smaçlar, yayınlar',
	seo_meta_title_featured: 'NBA Maçlarını ve Özetleri İzleyin | NBA.com',
	seo_meta_desc_featured: 'Ücretsiz NBA özet, haber ve analiz videolarını izleyin. Ayrıca, canlı maçları en sevdiğiniz cihazlarda izlemek için NBA TV ve League Pass aboneliklerini keşfedin.',
	seo_meta_keywords_featured: '',
	seo_meta_title_nbatv: 'NBA TV - Canlı Maçlar ve Gün Boyu Kesintisiz Yayın | NBA.com',
	seo_meta_desc_nbatv: 'Canlı NBA TV maçlarını veya efsaneleşmiş klasik maçları seyredin. Ayrıca, ligin dört bir yanından stüdyo programlarına ve analizlere erişin.',
	seo_meta_keywords_nbatv: 'NBA TV Kanalı, galibiyetler, parke klasikleri, nba canlı, gerçek nba, nba gametime, fantezi insider, stüdyo programları, sıçrayışlar',
	seo_meta_title_classicgames: 'NBA TV ile Klasik Maçları  ve Daha Fazlasını İzleyin | NBA.com',
	seo_meta_desc_classicgames: 'NBA TV ile efsaneleşmiş NBA eşleşmelerini seyredin. Ayrıca, NBA TV maçlarını canlı izleyin ve ligin dört bir yanından stüdyo programlarına ve analizlere erişin.',
	seo_meta_keywords_classicgames: '',
	seo_meta_pre_title_videolist: 'İçeriği Buradan İzleyin | NBA.com',
	seo_meta_title_videolist: '{0} İçeriğini Buradan İzleyin | NBA.com',
	seo_meta_desc_videolist: '{0} videolarını buradan izleyin. Ayrıca, canlı maçları en sevdiğiniz cihazlarda izlemek için NBA TV ve League Pass aboneliklerini keşfedin.',
	seo_meta_title_videolist_show: '{0} yayınını NBA TV ile izleyin | NBA.com',
	seo_meta_desc_videolist_show: '{0} içeriğini buradan izleyin. Ayrıca, NBA TV maçlarını canlı seyredin ve klasik maçlarla analizlere erişin.',
	seo_meta_keywords_videolist_show: '',
	seo_meta_title_videolist_feed: '{0} Yayınını Buradan İzleyin | NBA.com',
	seo_meta_desc_videolist_feed: '{0}videolarını buradan izleyin. Ayrıca, canlı maçları en sevdiğiniz cihazlarda izlemek için NBA TV ve League Pass aboneliklerini keşfedin.',
	seo_meta_keywords_videolist_feed: '',
	seo_meta_keywords_videolist: '',
	seo_meta_title_shows: 'NBA TV ile Stüdyo Programlarını ve Daha Fazlasını İzleyin | NBA.com',
	seo_meta_desc_shows: 'En güncel NBA TV Programlarını ve Bölümlerini keşfedin ve seç-izle seçeneğiyle izleyin. Ayrıca, canlı NBA TV maçlarını seyredin ve klasik maçlarla analizlere erişin.',
	seo_meta_keywords_shows: '',
	// Common Page Meta
	seo_meta_title_home: 'Ana Sayfa | NBA.com',
	seo_meta_desc_home: '',
	seo_meta_keywords_home: '',
	seo_meta_title_channels: 'Kanallar | NBA.com',
	seo_meta_desc_channels: '',
	seo_meta_keywords_channels: '',
	seo_meta_pre_title_channel: 'Kanal | NBA.com',
	seo_meta_pre_title_categories: 'Kategoriler | NBA.com',
	seo_meta_title_categories: 'Kategoriler | NBA.com',
	seo_meta_desc_categories: '',
	seo_meta_keywords_categories: '',
	seo_meta_pre_title_category: 'Kategori | NBA.com',
	seo_meta_title_category: 'Kategori | NBA.com',
	seo_meta_desc_category: '',
	seo_meta_keywords_category: '',
	seo_meta_pre_title_video: 'Videoyu Buradan İzleyin | NBA.com',
	seo_meta_pre_title_event: 'Etkinliği Buradan İzleyin | NBA.com',
	seo_meta_title_events: 'Etkinlikler | NBA.com',
	seo_meta_desc_events: '',
	seo_meta_keywords_events: '',
	seo_meta_title_event: '{0} Yayınını Buradan İzleyin | NBA.com',
	seo_meta_desc_event: '{0} içeriklerini buradan izleyin. Ayrıca, canlı maçları en sevdiğiniz cihazlarda izlemek için NBA TV & League Pass aboneliklerini keşfedin.',
	seo_meta_keywords_event: '',
	seo_meta_title_search: 'Ara | NBA.com',
	seo_meta_desc_search: '',
	seo_meta_keywords_search: '',
	seo_meta_title_notfound: 'Sayfa Bulunamadı | NBA.com',
	seo_meta_desc_notfound: '',
	seo_meta_keywords_notfound: '',
	seo_meta_pre_title_game: 'Maçı Buradan İzleyin | NBA.com',
	seo_meta_title_game: '{0} Yayınını Buradan İzleyin | NBA.com',
	seo_meta_desc_game: '{0} içeriklerini buradan izleyin. Ayrıca, canlı maçları en sevdiğiniz cihazlarda seyretmek için NBA TV ve League Pass aboneliklerini keşfedin.',
	seo_meta_keywords_game: '',
	seo_meta_title_video: '{0} Yayınını Buradan İzleyin | NBA.com',
	seo_meta_desc_video: '{0} içeriklerini buradan izleyin. Ayrıca, canlı maçları en sevdiğiniz cihazlarda seyretmek için NBA TV ve League Pass aboneliklerini keşfedin.',
	seo_meta_keywords_video: 'NBA Videoları, NBA Özetler, Basketbol Videoları, en güzel hareketler, smaçlar, yayınlar',
	seo_meta_title_episode: '{0} Yayınını NBA TV ile İzleyin | NBA.com',
	seo_meta_desc_episode: '{0} içeriklerini buradan seyredin. Ayrıca, NBA TV maçlarını canlı izleyin ve klasik maçlarla analizlere erişin.',
	seo_meta_keywords_episode: 'NBA Videoları, NBA Özetler, Basketbol Videoları, en güzel hareketler, smaçlar, yayınlar',
	seo_meta_title_channel: 'Canlı NBA TV | NBA.com',
	seo_meta_desc_channel: 'NBA TV Canlı ile 24 saat boyunca, her hafta canlı ve arşiv maçlara ulaşabildiğiniz NBA TV yayını, Stüdyo programları ve analizler elinizin altında',
	seo_meta_keywords_channel: 'NBA TV Kanalı, galibiyetler, parke klasikleri, nba canlı, gerçek nba, nba gametime, fantezi insider, stüdyo programları, sıçrayışlar',
	seo_meta_title_tvguide: 'NBA TV Canlı Yayın Programı | NBA.com',
	seo_meta_desc_tvguide: 'Canlı NBA TV maçlarını ve canlı stüdyo programlarını NBA TV ile en sevdiğiniz cihazınızda ne zaman izleyebileceğinizi görün. Ayrıca seç-izle stüdyo programlarına ve analizlere erişin.',
	seo_meta_keywords_tvguide: 'NBA TV Kanalı, galibiyetler, parke klasikleri, nba canlı, gerçek nba, nba gametime, fantezi insider, stüdyo programları, sıçrayışlar',

	// Common
	timezone: 'ET',
	default_feed_error_message: 'Ters giden bir şeyler var, içerik şu anda mevcut değil. Tekrar deneyebilirsiniz.',
	watch_in_app: 'NBA UYGULAMASINDA İZLE',
	ad_blocked_message: 'Reklam Engelleyici Algılandı: NBA.com içeriği reklamlarla desteklenmektedir. İçeriğimizin keyfini çıkarmaya devam etmek için lütfen reklam engelleyicinizi kapatın.',

	// Item
	no_content: 'İçerik Yok',
	see_more: 'Daha Fazlası',
	now_playing: 'ŞİMDİ OYNANIYOR',
	nba_tv_lock: 'NBA TV',
	league_pass_lock: 'League Pass',
	league_pass_premium_lock: 'LP PREMIUM',
	error_max_limit_favorite: 'Favori video ekleme üst sınırına ulaştınız. Lütfen daha fazla eklemeden önce bazı favori videolarınızı kaldırın.',
	item_live: 'Canlı:',
	add_favourite_title: 'FAVORİLERE EKLE',
	remove_favourite_title: 'FAVORİLERDEN KALDIR',
	// Channel: Schedule
	p_channel_live: 'Canlı:',
	p_channel_schedule_title: 'NBA TV Takvimi',
	p_channel_schedule_watch: 'İzle',
	p_channel_live24x7_title: 'NBA TV 7/24',
	p_channel_live24x7_see_full_schedule: 'Tüm Takvimi Gör',
	p_channel_live24x7_up_next: 'sırada',
	p_channel_live24x7_on_demand: 'NBA TV: Seç-İzle',
	p_channel_live24x7_collection: 'Koleksiyon',
	p_channel_live24x7_demand_1_logo_text: 'orijinal programlar',
	p_channel_live24x7_demand_1_show_name: 'NBA TV Programları',
	p_channel_live24x7_demand_1_show_desc: 'Shaqtin\' a Fool, Beyond the Paint, Game Time ve Basketball Stories gibi orijinal NBA TV programları',
	p_channel_live24x7_demand_2_logo_text: 'Klasik Maçlar',
	p_channel_live24x7_demand_2_show_name: 'NBA | Klasik Maçlar',
	p_channel_live24x7_demand_2_show_desc: '2000 yılından günümüze tüm final eşleşmelerini, ligin tarihi anlarını ve efsanevi oyuncuları içeren tam uzunluktaki Klasik Maçları izleyin',

	// Channel: Clips
	p_channel_error_msg: 'Henüz mevcut değil',

	// Channel: detail
	p_channel_category_title: 'NBA TV',
	p_channel_playlist_title: 'Program',

	// NBA TV Shows:
	p_nba_tv_shows: 'NBA TV Programları',
	p_nba_tv_no_access_title: '7/24 NBA: Maç analizleri, stüdyo analizleri, orijinal programlar ve daha fazlası ile uzak kalmayın!',
	p_nba_tv_no_access_desc: 'Canlı maçları, programları ve klasik maçları seç-izle ile seyredin.',
	p_nba_tv_no_access_note: 'Karartmalar geçerli olabilir',

	// tv show item
	tv_show_item_latest_episode: 'son bölüm',
	tv_show_item_no_latest_episode: 'son bölüm yok',
	see_all: 'Hepsini Gör',
	// header
	header_menu_watch: 'İzle',
	header_menu_featured: 'ÖNE ÇIKAN',
	header_menu_nba_tv: 'NBA TV',
	header_menu_league_pass: 'League Pass',

	// search
	players: 'Oyuncular',
	videos: 'Videolar',
	teams: 'Takımlar',
	most_searched: 'EN ÇOK ARANANLAR',
	no_result: 'Veri Yok',
	search_filter_type_most_relevant: 'En ilgili',
	search_filter_type_most_viewed: 'En çok görüntülenen',
	search_filter_type_most_recent: 'En yeni',
	search_filter_type_last_30_days: 'Son 30 gün',
	search_filter_type_last_6_months: 'Son 6 ay',
	search_result_label: '\'{keyword}\' için arama sonuçları',
	search_result_info: '{keyword} için tüm sonuçları görüntüleyin',
	search_placeholder: 'Video kütüphanesinde ara',
	load_more: 'Daha fazla yükle...',

	// button
	button_subscribe: 'Abone ol',
	button_sign_in: 'Oturum aç',
	button_tv_provider: 'TV Sağlayıcı Seçin',

	// league page
	p_league_pass_no_access_title: 'Bilgisayarınız, akıllı telefonunuz ve TV\'niz de dahil olmak üzere tüm cihazlarda maçların canlı yayınlarını veya tekrarlarını izleyin!',
	p_league_pass_no_access_desc: 'Aksiyona giriş biletiniz: tüm ligi ya da tuttuğunuz takımı izleyin, tek bir maç seçin veya daha fazla seçeneği inceleyin.',
	p_league_pass_no_access_note: 'Şartlara tabidir',
	// Video
	category_title: 'Video',
	p_video_playlist_title: 'Oynatma listesi',
	p_video_episode_text: 'Bölüm',
	p_no_access_league_pass_title: 'İzlemek için NBA League Pass kilidini açın:',
	p_no_access_league_pass_premium_title: 'Unlock NBA League Pass Premium to watch:',
	p_no_access_league_pass_desc: 'Aksiyona giriş biletiniz: tüm ligi ya da tuttuğunuz takımı izleyin, tek bir maç seçin veya daha fazla seçeneği inceleyin.',
	p_no_access_league_pass_terms: 'Şartlara tabidir',
	p_no_access_league_pass_geo_desc: 'Bulunduğunuz yer nedeniyle bu maçı NBA League Pass ve NBA TV ile görüntüleyemezsiniz. Bu maçların tekrarı, NBA League Pass aboneleri için yayın tarihinden 3 gün sonra hazır olacak. Bölgenizdeki yayınları nereden izleyebileceğiniz konusunda lütfen yerel TV ve radyo yayıncı kuruluşlarınızın programlarına göz atın.',
	p_no_access_league_pass_not_found_desc: 'Üzgünüz, istediğiniz video bulunamadı.',
	p_no_access_event_geo_desc: 'Bu yayın Amerika Birleşik Devletleri ve Kanada\'da izlenemez. Seyretmek için lütfen ABD\'de ESPN\'i, Kanada\'da ise TSN veya Sportsnet\'i açın.',
	p_no_access_event_not_found_desc: 'Üzgünüz, istediğiniz etkinlik bulunamadı.',
	p_no_access_nba_tv_title: 'İzlemek için NBA TV\'nin kilidini açın:',
	p_no_access_nba_tv_desc: 'Canlı maçların yanı sıra programları ve klasik maçları seç-izle ile seyredin.',
	p_no_access_nba_tv_terms: 'Şartlara tabidir',
	p_no_access_nba_tv_geo_desc: 'Bulunduğunuz yer nedeniyle bu maçı NBA League Pass ve NBA TV ile görüntüleyemezsiniz. Bu maçların tekrarı, NBA League Pass aboneleri için yayın tarihinden 3 gün sonra hazır olacak. Bölgenizdeki yayınları nereden izleyebileceğiniz konusunda lütfen yerel TV ve radyo yayıncı kuruluşlarınızın programlarına göz atın.',
	p_no_access_nba_tv_not_found_desc: 'Üzgünüz, istediğiniz kanal bulunamadı.',
	p_no_access_up_next: 'Sırada:',
	p_video_completed_title: 'Oynatma Listesi Tamamlandı',
	p_video_completed_desc: 'Göz atmak için geri gidin veya size özel bir sonraki oynatma listesine bakın',
	p_video_share_to: 'Paylaş:',
	p_video_more_to_watch: 'İzlemek İçin Daha Fazlası:',
	p_event_section_title: 'ETKİNLİK',

	// Event
	p_event_playlist_title: 'Oynatma listesi',
	p_event_button_watch: 'İzle',
	p_event_button_listen: 'Dinle',
	p_event_button_ticket: 'Bilet',

	// notfound page
	notfound: 'Maalesef istediğiniz sayfa bulunamadı.',
	notfound_desc: 'Lütfen hatalar için URL\'yi kontrol edin.<br/> Ayrıca içeriğinizi bulmak için sitenin gezinme veya arama aracını kullanmayı deneyebilirsiniz.',

	// Modal - PCM
	modal_pcm_header_title: '',
	modal_pcm_body_title: '',
	modal_pcm_body_description: 'NBA League Pass hesabınız, izin verilen maksimum yayın akışı sayısına ulaştı. Bu cihazda izlemeye devam etmek için \'Devam Et\' düğmesine dokunun.',
	modal_pcm_custom: 'Devam et',
	modal_pcm_close: 'İptal',
	modal_pcm_ok: 'Tamam',

	// Modal - Unsupported
	modal_video_unsupported_header_title: '',
	modal_video_unsupported_body_title: '',
	modal_video_unsupported_body_description: 'Bu video cihazınızda oynatılamaz. Daha fazla yardım için <a href=\'https://neulion-a.akamaihd.net/nlweb/h5support/player.html\' target=\'_blank\'>BURAYA</a> tıklayın.',
	modal_video_unsupported_custom: '',
	modal_video_unsupported_close: 'Tamam',
	modal_video_unsupported_ok: 'Tamam',

	// FreeSample
	freesample_notice_time: 'Kalan süre',
	freesample_notice_title: '{0} Dakikalık NBA Pass Erişiminin Tadını Çıkar',
	freesample_notice_desc: '{0} dakikan sona erdiğinde içeriğe erişmeye devam etmek için tam League Pass paketine abone ol.',
	freesample_notice_subscribe_button: 'Abone ol',
	freesample_notice_cancel_button: 'İstediğin Zaman İptal Et',
	freesample_popup_title: 'ERİŞİMİN SONA ERDİ',
	freesample_popup_subtitle: 'Süper NBA içeriklerini daha fazla izlemek için League Pass\'e Abone ol.',
	freesample_popup_link: 'DAHA FAZLA BİLGİ EDİNİN!',
	freesample_popup_get_minutes_button: '{0}  DAKİKA KAZAN',

	// Video list
	reg_required_desc: 'Bu içeriği görüntülemek için oturum açmanız gerekiyor',
	favorite_teams_title: 'Favori Takımlar',
	bookmarked_title: 'Kaydedildi',
	watch_history_title: 'İzlemeye Devam Edin',
	game_schedule_title: 'Maç Programı',
	recommended_title: 'Tavsiye edilen',
	season_text: 'Sezon',

	// profile page
	section_information_title: 'Bilgilerim',
	section_information_desc: 'Kişisel bilgilerinizi güncelleyin',
	section_information_email: 'E-posta',
	section_information_email_update: 'Email Adresinizi Güncelleyin',
	section_information_password: 'Şifre',
	section_information_password_update: 'Şifre Değiştir',
	section_information_social: 'Sosyal Bağlantılar',
	section_information_nosocial_message: 'Hiç bağlantılı hesabınız yok.',
	section_information_firstname: 'Ad',
	section_information_lastname: 'Soyad',
	section_information_birth: 'Doğum Tarihi',
	section_information_country: 'Ülke/Bölge',
	section_information_postalcode: 'Posta Kodu',
	section_information_edit: 'Düzenle',
	section_tv_provider_title: 'TV Sağlayıcım',
	section_tv_provider_desc: 'TV sağlayıcınız üzerinden canlı maçlara ve yayınlara erişin.',
	section_tv_provider_faq: 'TV Sağlayıcı SSS',
	section_tv_provider_sign_out: 'Oturumu Kapat',
	section_tv_provider_sign_in: 'TV Sağlayıcıya Oturum Aç',
	section_fantasy_title: 'Fantezi',
	section_fantasy_desc: 'Fantezi hesap bilgilerinizi görüntüleyin',
	section_fantasy_displayname: 'Ekran Adı',
	section_marketing_title: 'Email Tercihleri',
	section_marketing_desc: 'Pazarlama iletişimi ve kullanıcı gizliliği tercihlerinizi görüntüleyin',
	section_marketing_newsletters: 'Haber Bültenleri',
	section_marketing_message: 'NBA Mesaj ve Tanıtımları',
	section_marketing_newsletters_desc_1: 'NBA haberleri her gün gelen kutunuza gönderilir',
	section_marketing_newsletters_desc_2: 'NBA\'in resmi gelişim ligi olan NBA G League\'den Haberler ve Makaleler',
	section_marketing_newsletters_desc_3: 'NBA\'in altyapı basketbol girişiminden Jr. NBA haberleri ve içerikler',
	section_marketing_newsletters_desc_4: 'NBA uygulamasındaki en son özellikler, ayrıca League Pass güncellemeleri ve teklifleri',
	section_marketing_newsletters_desc_5: 'NBA\'den özel bilet teklifleri, ortakların teklifleri, etkinlik ve ürün indirimleri',
	section_marketing_newsletters_desc_6: 'Haftalık olarak gelen kutunuza gönderilen, elle seçilmiş NBA haberleri ve içeriği',
	section_marketing_newsletters_desc_7: 'WNBA ve ortaklarından WNBA haberleri ve teklifler',
	section_marketing_personal_title: 'Kişisel Bilgilerim',
	section_marketing_personal_desc: 'NBA tarafından, NBA ve NBA ortaklarının ürünleri ve girişimleri hakkında tarafıma mesaj ve reklam gönderilmesi için kişisel bilgilerimi kullanabilirsiniz.',
	section_marketing_update_button: 'Pazarlama Tercihlerini Güncelle',
	section_marketing_update_success: 'Tercihleriniz güncellendi.',
	section_ccpa_title: 'Kişisel bilgilerimi satmayın',

	// profile edit modal
	email_modal_title: 'email adresini güncelle',
	email_modal_new_email_label: 'yeni email adresi',
	email_modal_update: 'Güncelleme',
	email_modal_cancel: 'İptal',
	password_modal_title: 'Şifre Değiştir',
	password_modal_current_label: 'Şimdiki Şifre:',
	password_modal_new_label: 'Yeni Şifre:',
	password_modal_confirm_label: 'Şifreyi Onayla',
	password_modal_update: 'Güncelleme',
	password_modal_cancel: 'İptal',
	personal_modal_title: 'kişisel bilgileri güncelle',
	personal_modal_email: 'E-posta',
	personal_modal_password: 'Şifre',
	personal_modal_birth: 'Doğum Tarihi',
	personal_modal_social: 'Sosyal Bağlantılar',
	personal_modal_firstname: 'Ad',
	personal_modal_lastname: 'Soyad',
	personal_modal_country: 'Ülke/Bölge',
	personal_modal_postalcode: 'Posta Kodu',
	personal_modal_zipcode: 'posta Kodu',
	personal_modal_postalcode_invalid_message: 'Geçerli bir posta kodu olmalı',
	personal_modal_zipcode_invalid_message: 'Geçerli bir posta kodu olmalı',
	personal_modal_update: 'Güncelleme',
	personal_modal_cancel: 'İptal',

	// payflow
	payflow_profile_name: 'İsim',
	payflow_profile_email: 'E-posta',

	// account page
	header_menu_account_my_account: 'Hesabım',
	header_menu_account_manage_account: 'Hesabı Yönet',
	header_menu_account_favorite_teams: 'Favori Takımlar',
	header_menu_account_favorite_players: 'Favori Oyuncular',
	header_menu_account_viewing_history: 'Görüntüleme Geçmişi',
};
